// production
export const config = {
    backendUrl: 'https://api.synswi.com',
    tokenizationBaseUrl: "https://tokenization-form.synswi.com",
}

// sandbox
// export const config = {
//     backendUrl: 'https://api-sandbox.synswi.com',
//     tokenizationBaseUrl: "https://tokenization-form-sandbox.synswi.com",
// }

// dev
// export const config = {
//     backendUrl: 'https://api-dev.synswi.com',
//     tokenizationBaseUrl: "https://tokenization-form-dev.synswi.com",
// }

